<template>
  <div class="container-fluid gt-0" style="padding:0;overflow-x:hidden">
      <div> View Data :
           <select v-model="flag" @change="do_chgview()">
             <option value=0 selected>In Process</option>
             <option value=1>Approved</option>
             <option value=2>Reject</option>
           </select>
      </div>
      <div style='text-align:center;font-size:18pt;margin:auto;width:auto;font-weight:bold'>
          USER APPROVAL</div>

      <div v-if="mode == 'browse'" class="table-responsive" style='font-size:10pt'>
        <table class="table table-striped table-bordered font-custom">
            <thead>
                <tr>
                    <th>CHECK</th>
                    <th v-for="h in brwheader" :key="h"> {{ h }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="myrow in brwdata" :key="myrow.cols[0]">
                    <td><input type="checkbox" :value="myrow.cols[0]" 
                        @click="do_checkbox(myrow.cols[0])" 
                          v-model="myrow.selected"/></td>
                    <td v-for="c in myrow.cols" :key="c" class="colpad">
                         {{ c }}
                    </td>
                </tr>
            </tbody>
        </table>
      </div>

      <div>
        <br>
        <div v-if="errormsg !=''" class="border mb-3" 
          style='color:red;background:yellow'>
          {{errormsg}}
        </div>

        <div v-if="mode=='browse'">
          <table align="center">
          <tr>

            <td>
            <button class="btn btn-primary btn-block mb-4" @click="getbrowse('next')"> 
              Next</button></td>

            <td>
            <button class="btn btn-primary btn-block mb-4" @click="getbrowse('prev')"> 
              Prev</button></td>

            <td> 
            <button class="btn btn-primary btn-block mb-4" @click="getbrowse('first')"> 
              First</button></td>
            <td> 
            <button class="btn btn-primary btn-block mb-4" @click="getbrowse('last')"> 
              Last</button></td>

            <td> <div style="width:30px"></div></td>

            <td v-if="flag == 0">
              <button class="btn btn-primary btn-block mb-4" @click="show_update()"> 
              Update</button></td>

            <td v-if="flag != 0">
              <button class="btn btn-primary btn-block mb-4" @click="show_view()"> 
              View</button></td>

          </tr></table>
        </div>
      </div>
  </div>


  <div class="modal" id="MODAL102" tabindex="-1" aria-labelledby="MODAL102Label" aria-hidden="true">
    <div class="modal-dialog" style="width:40rem">
      <div class="modal-content">
        <div class="modal-header" style='background: #9999FF;padding:2px'>
          <p class="modal-title">FIELD UPDATE</p>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <table>
           <tr><td>LOGIN</td><td>:</td><td>{{login}}</td></tr>


           <tr><td>FIELDNAME</td><td>:</td><td>
              {{ showtarget("fieldname") }}
           </td></tr>
           <tr><td>OLDDATA</td><td>:</td><td>
              {{ showtarget("olddata") }}
           </td></tr>
           <tr><td>NEWDATA</td><td>:</td><td>
              {{ showtarget("newdata") }}
           </td></tr>

           <tr><td>REQ BY</td><td>:</td><td>
              {{ showtarget("reqby") }}
           </td></tr>

           <tr><td>REASON</td><td>:</td><td>
             <input id="inpuser02" type="text" v-model="rejectdesc"
                placeholder="Reason for rejection"></td></tr>
          </table>
          <br/>
          <div style='margin-left:150px'>
               <button type="button" data-bs-dismiss="modal" 
                 @click="do_update(0)">Reject</button>
               <button type="button" data-bs-dismiss="modal" 
                 @click="do_update(1)">Approve</button>
          </div>

          <div v-if="errormsg !=''" class="border mb-3" 
              style='color:red;background:yellow'>
              {{errormsg}}
          </div>

        </div>
      </div>
    </div>
  </div>

  <div class="modal" id="MODAL103" tabindex="-1" aria-labelledby="MODAL103Label" aria-hidden="true">
    <div class="modal-dialog" style="width:30rem">
      <div class="modal-content">
        <div class="modal-header" style='background: #9999FF;padding:2px'>
          <p class="modal-title">FIELD UPDATE</p>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <table>
           <tr><td>LOGIN</td><td>:</td><td>{{login}}</td></tr>

           <tr><td>STATUS</td><td>:</td><td>
              {{ showtarget("status") }}
           </td></tr>

           <tr><td>INFO</td><td>:</td><td>
              {{ showtarget("reason") }}
           </td></tr>

           <tr><td>FIELDNAME</td><td>:</td><td>
              {{ showtarget("fieldname") }}
           </td><td>
              {{ showtarget("newdata") }}
           </td></tr>

           <tr><td>REQ BY</td><td>:</td><td>
              {{ showtarget("reqby") }}
           </td><td>
              {{ showtarget("reqdate") }}
           </td></tr>

           <tr><td>APP BY</td><td>:</td><td>
              {{ showtarget("appby") }}
           </td><td>
              {{ showtarget("appdate") }}
           </td></tr>


          </table>
          <div style='margin-left:200px'> 
               <button type="button" data-bs-dismiss="modal" 
                 @click="closewin()">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios'
import bootstrap from 'bootstrap/dist/js/bootstrap.js'

export default {
  name: 'KeyInput',
  props: {
    msg: String
  },
  mounted() {
    this.getconfig();
    this.getbrowse('first');
  },
  computed: {
    title() {
      if (this.mode == "browse")
        return "KEY TABLES"
      else
        return "ADD KEY"

    },
    startseq() {
      let x = this.brwdata[0] ;
      if (! x) return 0 ;
      if (! x.cols) return 0 ;
      return x.cols[0] ;
    },
    userlogin() {
      return this.$store.getters.userlogin ;
    },
    curpage() {
      return this.$store.getters.curpage ;
    },
    targetobj() {
      for (let obj of this.brwdata) {
        if (obj.selected) 
          return parseInt(obj.cols[0]) ;
      }
      return 0 ;
    },
    targetrow() {
      var i = 0 ;
      for (let obj of this.brwdata) {
        i++ ;
        if (obj.selected) 
          return i ;
      }
      return 0 ;
    }
  },
  data() {
    return { 
      flag : 0,
      datalabel : 'label',
      change : 0,
      mode : "browse",
      config : null,
      userroles : [ { id : 0, name : "notloaded", access : 0 } ],
      rejectdesc : '',
      numoferr : 0,
      errormsg : '',
      login : '',
      brwheader : [ "id", "LOGIN", "FIELDNAME", "NEWDATA", "REQBY", "REQDATE", "APRBY", "APRDATE" ],
                    // 8:REJECT, 9:OLDVALUE
      brwdata   : [ 
                    { "selected" : false,
                      "cols" : [ 0, "USER1", "NOFIELD", "NODATA",
                        "07/08/2023 10:00", "SYS", "APRBY", "APRDATE" ]
                    }
                  ],
      actualheader : null,
      actualdata : null,
      name : '',
    }
  },
  methods : {
    do_chgview() {
      this.getbrowse("Last") ;
    },
    copy_brwdata() {  // copy and filter actualdata to brwdata 
      var upto = (this.flag == 0)  ? 5 : 7 ;
      this.brwdata = [] ;
      for (var i = 0 ; i < this.actualdata.length ; i++) {
         this.brwdata[i] = { "selected" : false, cols : [] }  ;
         for (var j = 0 ; j < this.actualdata[i].cols.length && j <= upto ; j++) {
           this.brwdata[i].cols[j] = this.actualdata[i].cols[j] ;
         }
         if (this.brwdata[i].cols[2] == "password")
           this.brwdata[i].cols[3] = "******" ;
         else
         if (this.brwdata[i].cols[2] == "role") {
           var idx = parseInt ( this.brwdata[i].cols[3] ) ;
           this.brwdata[i].cols[3] = this.userroles[ idx ].name ;
         }
      }
      this.brwheader = []  ;
      for (j = 0 ; j <= upto ; j++) {
          this.brwheader[j] = this.actualheader[j] ;
      }
    },
    filter_role(role) {
       for (var i = 0 ; i < this.userroles.length ; i++) {
         if (this.userroles[i].id == parseInt(role)) {
           return this.userroles[i].name ;
         }
       }
       return "none" ;
    },
    do_checkbox(seq) {
      for ( let r of this.brwdata ) {
        if (r.cols[0] != seq && r.selected) 
          r.selected = false ;
      }
    },
    closewin() {
    },
    showtarget(arg) {
       if (arg == "status") {
         if (this.flag == 0) 
           return "In Process" ;
         else if (this.flag == 1) 
           return "Approved" ;
         else if (this.flag == 2)
           return "Rejected" ;
         else
           return "undefined" ;
       }
       var row = this.targetrow - 1;
       if (row < 0)
           return "NO ROW DEFINED!" ;

       // "id", "LOGIN", "FIELDNAME", "NEWDATA", "REQBY", "REQDATE", "APRBY", "APRDATE" 

       if (arg == "olddata") {
         if (this.actualdata[row].cols[2] == "role") {    // password
           let x = parseInt(this.actualdata[row].cols[9]) ;   // oldval 
           return this.userroles[ x ].name ;
         }
         else
           return this.actualdata[row].cols[9] ;   // oldval 
       }
       if (arg == "reason") 
         return this.actualdata[row].cols[8] ;   // reason 
       else if  (arg == "fieldname")
         return this.actualdata[row].cols[2] ;
       else if (arg == "newdata") {
         if (this.actualdata[row].cols[2] == "password") // password
           return "******" ;
         else 
         if (this.actualdata[row].cols[2] == "role") {    // password
           var idx = parseInt(this.actualdata[row].cols[3]) ;
           return this.userroles[ idx ].name ;
         }
         else
          return this.actualdata[row].cols[3] ;
       }
       else if (arg == "reqby") 
          return this.actualdata[row].cols[4] ;
       else if ( arg == "reqdate") 
          return this.actualdata[row].cols[5] ;
       else if (arg == "appby") 
          return this.actualdata[row].cols[6] ;
       else if (arg == "appdate") 
          return this.actualdata[row].cols[7] ;
       return arg ;
    },
    do_update(is_approved) {
       let req = this.$store.getters.controller_url +
        "/prosw/CFG/userupd/save?swapid=" + 
              this.$store.getters.controllerid + 
          "&seq=" + this.startseq +
          "&target=" + this.targetobj +
          "&flag=" + this.flag ;
  
        this.errormsg = '' ;
        tar-- ;

        if (is_approved == 0 && this.rejectdesc == "")
          this.errormsg = "Reject has to give reason" ;

       if (this.errormsg != '' ) return ;
       var tar = this.targetrow - 1;
       if (tar < 0) {
            this.errormsg = "No Target Object Please Check target row"  ;
            return ;
       }

       let formData = new FormData();
       formData.append('approved', is_approved);
       formData.append('rejectdesc', this.rejectdesc);
       formData.append('target', this.brwdata[tar].cols[0])
       formData.append('sendto', this.config.sendto);
       formData.append('command', "update") ;

       axios.post(req, formData, {
                    headers: {
                        'Pswtoken': this.$store.getters.pswtoken, 
                        'Content-Type': 'multipart/form-data'
                    }
       }).then ( (response) => { 
           if (typeof response.data == "object") {
              let obj = response.data ;
              this.errormsg = "RC: " + obj.RC + " -- " + obj.RDESC  ;
              if (obj.RC == "00")  {
                this.actualdata = response.data.RESULT.brwdata ;
                this.actualheader = response.data.RESULT.brwheader ;
                this.copy_brwdata() ;
                this.mode = 'browse' ;
              }
            }
            else
              this.errormsg = "Invalid response" ;
           })
           .catch ( err => {  console.log(err) ; 
                              this.writemsg ( "RECV ERROR RESPONSE") } )  
    },
    changemode (newmod) {
      this.errormsg = "" ;
      this.mode = newmod ;
    },
    getbrowse(cmd) {
       let req = this.$store.getters.controller_url +
              "/prosw/CFG/userupd/" + cmd + "?swapid=" + 
              this.$store.getters.controllerid + "&seq=" + this.startseq + 
              "&flag=" + this.flag ;
        axios.get (req, {
            timeout: 10000,
            headers: {'Pswtoken': this.$store.getters.pswtoken } 
        }).then ( (response) => {
           if (typeof response.data != "object") 
              this.errormsg = "Invalid RESPONSE receive (not json)" ;
           else
           if (response.data.RC != "00")
              this.errormsg = "ERROR RESPONSE " + 
                        response.data.RC + " - " + response.data.RDESC ; 
           else {
              this.errormsg = "" ;
              this.actualdata = response.data.RESULT.brwdata ;
              this.actualheader = response.data.RESULT.brwheader ;
              console.log (this.actualdata) ;
              this.copy_brwdata() ;
           }
        }).catch ( (error) => { console.log(error) })
    },
    show_view() {

        var row = this.targetrow ;
        if (row == 0) {
            this.errormsg = "No Target Object Please Check target row"  ;
            return ;
        }

        let divmodal = document.getElementById( "MODAL103" ) ;
        let myModal = new bootstrap.Modal( divmodal, { backdrop : false }) ;

        divmodal.style.top =   '100px' ;
        divmodal.style.left =  '20px' ;

        if (this.errormsg == "") {
            this.login = this.brwdata[row - 1].cols[1] ;
        }
        else this.errormsg = "" ;
        myModal.show() ;
        return 0 ;
    },
    show_update() {

        var row = this.targetrow ;
        if (row == 0) {
            this.errormsg = "No Target Object Please Check target row"  ;
            return ;
        }

        let divmodal = document.getElementById( "MODAL102" ) ;
        let myModal = new bootstrap.Modal( divmodal, { backdrop : false }) ;

        divmodal.style.top =   '100px' ;
        divmodal.style.left =  '20px' ;

        if (this.errormsg == "") {
            this.login = this.brwdata[row - 1].cols[1] ;
        }
        else this.errormsg = "" ;
        this.rejectdesc = '' ;

        myModal.show() ;
        return 0 ;
    },
    do_action(cmd) {
       if (this.targetobj == 0) {
          this.errormsg = "No Target Object Please Check target row"  ;
          return ;
       }
       if (cmd == 'delete') {
         if (! confirm("Remove File ?")) return ;
       }
       let req = this.$store.getters.controller_url +
              "/prosw/CFG/userupd/" + cmd + "?swapid=" + 
              this.$store.getters.controllerid + "&seq=" + this.startseq +
                  "&target=" + this.targetobj ;
       axios.get (req, {
            timeout: 10000,
            headers: {'Pswtoken': this.$store.getters.pswtoken } 
        }).then ( (response) => {
           if (typeof response.data != "object") 
              this.errormsg = "Invalid RESPONSE receive (not json)" ;
           else
           if (response.data.RC != "00")
              this.errormsg = "ERROR RESPONSE " + 
                        response.data.RC + " - " + response.data.RDESC ; 
           else {
              this.errormsg = response.data.RDESC ;
              this.brwdata = response.data.RESULT.brwdata ;
              this.brwheader = response.data.RESULT.brwheader ;
           }
        }).catch ( (error) => { console.log(error) })
    },
    getconfig() {
      this.config = this.$store.getters.usermgmt ;
      this.userroles = this.config.userroles ;
      this.selected_role = this.userroles[0].id ;
      this.showkeys = this.config.showkeys ;
      let a = []
      for (let i = 0 ; i < this.showkeys.length ;i++) {
                 a[i] = (this.showkeys[i] == "show") ? 1 : 0 ;
      }
      this.showkey  = a ;
    },
    toggle(idx) {
      this.showkey[idx] = ! this.showkey[idx];
    },
    writemsg(err) {
      if (this.numoferr > 0) 
         this.errormsg = err + "(" + this.numoferr + ")" ;
      else
         this.errormsg = err ;
      this.numoferr ++ ;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.colpad {
    padding: 0.1rem !important ;
}
.bd-login {
    padding: 2rem;
    margin:  auto;
    border-width: 1px;
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem;
    width : auto;
}
footer {
   position: absolute ;
   bottom : 1rem ;
}
.spaceleft {
  left : 1rem ;
  position : relative;
  color: grey ;
  font-size : 14pt ;

}
.mymodal {
    background-color: yellow;
}
header {
   position: absolute ;
   top : 0.5rem ;
   height : 3rem ;
}
</style>
